module.exports = __webpack_public_path__ + "static/img/a8.9b0079ee.png";